import type { IPatientRepository, PatientListQuery } from '@domain/data-contracts/patient-repository.interface';
import type { Patient } from '@domain/models/patient.interface';
import type { PagedResult } from '@domain/models/paging.interface';

export class PatientsService {
  public constructor(private readonly repo: IPatientRepository) {}

  public list(query: PatientListQuery): Promise<PagedResult<Patient>> {
    return this.repo.list(query);
  }
}
